import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import mdkController from "./mdk_controller"
import { showOverlay, hideOverlay, scrollToFirstError } from '../services/form_helper'

export default class extends mdkController {
  static targets = ['form'];
  static classes = ['errorm','readonly'];
  static values = {validateurl: String, validateflag: String};

  formTargetConnected(){
    const corpMailType = this.formTarget.querySelector("input[name='user[email_type]']");
    if (corpMailType != undefined){
      this.readonlyUserEmail(corpMailType);
    }
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(onSuccessCallback, onErrorCallback){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const formData = new FormData(this.formTarget);
    const flag = document.getElementById(this.validateflagValue);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(Object.keys(response).length > 0){
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
              }
            })
          });
          flag.value = 'false';
          if(typeof onErrorCallback == 'function'){
            onErrorCallback();
          }
        }else{
          flag.value = 'true';
          if(typeof onSuccessCallback == 'function'){
            onSuccessCallback();
          }
        }
      }
    });
  }

  onSubmit(){
    const flag = document.getElementById(this.validateflagValue);
    if(flag.value == 'true'){
      this.formTarget.submit();
    }
  }

  validateAndSubmit(event){
    const el = event.currentTarget;
    const target = this.formTarget;
    showOverlay();
    this.validateAll(function(){
      el.disabled = true;
      target.submit();
    }, function(){
      hideOverlay();
      scrollToFirstError('error-message');
    })
  }
  validateAndRegisterAndSubmit(event) {
    const el = event.currentTarget;
    const _this = this
    showOverlay();
    this.validateAll(function () {
        _this.register(function () {
          el.disabled = true;
          _this.formTarget.submit();
        })
      }, function(){
        hideOverlay();
        scrollToFirstError('error-message');
      }
    )
  }

  corpMail(e){
    const el = e.currentTarget;
    this.readonlyUserEmail(el);
  }
  readonlyUserEmail(el){
    const userMail = this.formTarget.querySelector("#user_email");
    if(el.value == "1"){
      userMail.classList.add(this.readonlyClass);
      userMail.readOnly = true;
    }else{
      userMail.classList.remove(this.readonlyClass);
      userMail.readOnly = false;
    }
  }
}
